import React from "react";
import styles from "./purchase-order-filter.module.scss";
import { Autocomplete, Field, Filter, DateRange, Button } from "components/commons";
import { locale } from "localization/en";
import { purchaseOrderStatus } from "data/constant/purchase-order-status";
import { purchaseOrderProducts } from "data/constant/purchase-order-products";
import SearchTypeField from "components/commons/search-field/search-type";
import { Path } from "enums";
import { useRouter } from "hooks";

const PurchaseOrderFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const searchType = [
    { label: locale.orderId, value: "orderId" },
    { label: locale.purchaseOrderNo, value: "purchaseOrderNumber" },
    { label: locale.salesOrderNo, value: "salesOrderNumber" },
  ];

  const router = useRouter();

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              maxDate={new Date()}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>

          <Field
            label={locale.status}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="status"
              value={filterState.status.value}
              options={purchaseOrderStatus}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
          <Field
            label={locale.products}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="productCode"
              value={filterState.productCode.value}
              options={purchaseOrderProducts}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            // startIcon={<span className="icon-download" />}
            exportButton
            onClick={() => router.push(Path.AddPurchaseOrder)}
          >
            {locale.createOrder}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default PurchaseOrderFilter;
